<!-- 项目首页 -->
<template>
    <div class='' v-loading="loading">
        <div class="home-box" id="home_box">
            <!-- 头部 -->
            <div class="header">
                <div class="fullScreen-btn fullScreen_close" @click="handleFullScreen(false)" v-if="fullScreen">
                    <i class="iconfont icon-quxiaoquanping_o"></i>
                </div>
                <div class="fullScreen-btn" @click="handleFullScreen(true)" v-else>
                    <i class="iconfont icon-icon-"></i>
                </div>
                <div class="project-name">
                    {{projectsystemInfo.project_system_name}}
                </div>
                <div class="now-time-box">
                    <p class="day">
                        {{year}}
                    </p>
                    <p class="time">
                        <span>{{time}}</span>
                        <span>{{week}}</span>
                    </p>
                </div>
            </div>
            
             <div class="warrper-box">
                <div class="sidebar-box" v-show="!fullScreen">
                    <sidebar></sidebar>
                </div>
                <!-- content -->
                <div class="home-content-box" :style="!fullScreen? 'margin-left: 180px;': 'margin-left: 0;'">
                    <div class="home-content-warpper">
                        <!-- left -->
                        <div class="cont-left">
                            <div class="cont-left-energy-totel cont-border"
                                v-loading="loading1" 
                                element-loading-spinner="el-icon-loading"
                                element-loading-background="rgba(41, 61, 110, 0.6)">
                                <!-- 能耗总览 -->
                                <div class="cont-left-totle">
                                    <div class="cont-title">
                                        能耗总览
                                    </div>
                                    <div class="cont-list">
                                        <div class="cont-item">
                                            <div class="cont-item-left">
                                                <p class="item-sub-title">
                                                    中央空调本月用电
                                                </p>
                                                <p class="item-number">
                                                   {{kt_totle}} KWh
                                                </p>
                                                <p class="item-tendency" style="margin-bottom: 8px;">
                                                    <span>去年同期：</span>
                                                    <span class="item-tendency-num">{{kt_increase_percentage}}</span>
                                                </p>
                                                <p class="item-tendency">
                                                    <span>去年总量：</span>
                                                    <span>{{kt_last_totle}} KWh</span>
                                                </p>
                                            </div>
                                            <!-- 空调用电月统计曲线图 -->
                                            <div class="cont-item-charts" id="chart_month_electricity">
                                
                                            </div>
                                        </div>
                                
                                        <div class="cont-item">
                                            <div class="cont-item-left">
                                                <p class="item-sub-title">
                                                    水泵本月用电
                                                </p>
                                                <p class="item-number">
                                                    {{bump_totle}}KWh
                                                </p>
                                                <p class="item-tendency" style="margin-bottom: 8px;">
                                                    <span>去年同期：</span>
                                                    <span class="item-tendency-num">{{bump_increase_percentage}}</span>
                                                </p>
                                                <p class="item-tendency">
                                                    <span>去年总量：</span>
                                                    <span>{{bump_last_totle}}KWh</span>
                                                </p>
                                            </div>
                                            <!-- 水泵月统计曲线图 -->
                                            <div class="cont-item-charts" id="chart_month_pump">
                                
                                            </div>
                                        </div>
                                
                                        <div class="cont-item" style="display:none;">
                                            <div class="cont-item-left">
                                                <p class="item-sub-title">
                                                    机房本月用电
                                                </p>
                                                <p class="item-number">
                                                    {{project_totle}}KWh
                                                </p>
                                                <p class="item-tendency" style="margin-bottom: 8px;">
                                                    <span>去年同期：</span>
                                                    <span class="item-tendency-num">{{increase_percentage}}</span>
                                                </p>
                                                <p class="item-tendency">
                                                    <span>去年总量：</span>
                                                    <span>{{last_project_totle}}KWh</span>
                                                </p>
                                            </div>
                                            <!-- 其他月统计曲线图 -->
                                            <div class="cont-item-charts" id="chart_month_other">
                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="cont-line"></div>
                                <div class="cont-left-day">
                                    <div class="cont-title">
                                        日用电量
                                        <div class="cont-title-box">
                                            <span class="cur-number">
                                                截止当前今日用电量 {{today_totle}} kWh
                                            </span>
                                            <span class="sub-contrast">对比</span>
                                            <div class="select-box">
                                                <el-select v-model="day" :popper-append-to-body="false" class="home-el-select" placeholder="请选择日期">
                                                    <el-option label="昨天" value="-1"></el-option>
                                                    <el-option label="1日" value="1" :disabled="true"></el-option>
                                                    <el-option label="2日" value="2" :disabled="true"></el-option>
                                                    <el-option label="3日" value="3" :disabled="true"></el-option>
                                                </el-select>
                                            </div>
                                            <span class="cur-number">
                                                {{otherday_totle}}Kwh
                                            </span>
                                            <span :class="day_percent_class">
                                                {{today_percentage}}
                                            </span>

                                            <div class="select-box select-system-type">
                                                <el-select v-model="type" :popper-append-to-body="false" class="home-el-select" @change="handleChangeType" placeholder="请选择类型">
                                                    <el-option label="空调系统用量" value="1"></el-option>
                                                    <el-option label="水泵用量" value="2"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 日用电量曲线图 -->
                                    <div class="cont-day-charts" id="chart_day_electricity"></div>
                                </div>

                                <!-- 箭头 -->
                                <div class="arrows-box">
                                    <span class="arrows-left-top"></span>
                                    <span class="arrows-left-bottom"></span>
                                    <span class="arrows-right-top"></span>
                                    <span class="arrows-right-bottom"></span>
                                </div>
                            </div>
                            <div class="cont-left-energy">
                                <!-- 节能概况 -->
                                <div class="energy-situation-box cont-border"
                                    v-loading="loading2" 
                                    element-loading-spinner="el-icon-loading"
                                    element-loading-background="rgba(41, 61, 110, 0.6)">
                                    <div class="cont-title">
                                        节能概况
                                        <span class="cont-title-tip">（纵坐标单位：元 横坐标：月）</span>
                                    </div>
                                    <div class="cont-day-charts" id="chart_year_conservation"></div>
                                
                                    <!-- 箭头 -->
                                    <div class="arrows-box">
                                        <span class="arrows-left-top"></span>
                                        <span class="arrows-left-bottom"></span>
                                        <span class="arrows-right-top"></span>
                                        <span class="arrows-right-bottom"></span>
                                    </div>
                                </div>
                                <!-- 在线情况 -->
                                <div class="device-status-box cont-border">
                                    <div class="cont-title">
                                        在线情况统计
                                    </div>
                                    <div class="device-list">
                                        <template v-for="(v, i) in online_status_statistic">
                                            <div class="device-item" :key="i">
                                                <div class="device-title icon-ele">
                                                    {{v.name}}
                                                </div>
                                                <div class="device-des">
                                                    <span>上线数/总数</span>
                                                    <span class="fr">{{v.online_status_sum}}/{{v.sum}}</span>
                                                </div>
                                                <div class="device-progress">
                                                    <div class="progress-w" :style="'width: ' + v.percent"></div>
                                                </div>
                                            </div>
                                        </template>

                                        <div class="nodata" v-if="online_status_statistic.length===0" style="color:#fff;">-- 暂无数据 --</div>
                                    </div>

                                    <!-- 箭头 -->
                                    <div class="arrows-box">
                                        <span class="arrows-left-top"></span>
                                        <span class="arrows-left-bottom"></span>
                                        <span class="arrows-right-top"></span>
                                        <span class="arrows-right-bottom"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- right -->
                        <div class="cont-right">
                            <!-- 天气 -->
                            <div class="weather-box cont-border"
                                v-loading="loading3" 
                                element-loading-spinner="el-icon-loading"
                                element-loading-background="rgba(41, 61, 110, 0.6)">
                                <div class="weather-img">
                                    <img :src="`/resources/homeimge/${wea_img}.png`" alt="">
                                </div>
                                <div class="weather-temp">
                                    <span class="weather-temp-num">{{tem}}</span>
                                    <span class="weather-temp-des">
                                        <span>°C</span>
                                        <span>（{{projectInfo.city}}）</span>
                                    </span>
                                </div>
                                <div class="weather-other-item">
                                    <span>温度分布</span>
                                    <span>{{tem2}}°C - {{tem1}}°C</span>
                                </div>
                                <div class="weather-other-item">
                                    <span>空气湿度</span>
                                    <span class="item-bg">{{humidity}}</span>
                                </div>
                                <div class="weather-other-item">
                                    <span>空气质量</span>
                                    <span class="item-bg item-bg2">{{air}} {{air_level}}</span>
                                </div>

                                <!-- 箭头 -->
                                <div class="arrows-box">
                                    <span class="arrows-left-top"></span>
                                    <span class="arrows-left-bottom"></span>
                                    <span class="arrows-right-top"></span>
                                    <span class="arrows-right-bottom"></span>
                                </div>
                            </div>
                        
                            <!-- 预警 -->
                            <div class="warning-message-box cont-border">
                                <div class="cont-title">
                                    实时预警
                                    <span class="cont-title-tip">（所有设备）</span>
                                    <span class="more">更多</span>
                                </div>
                                <div class="warning-header">
                                    <div class="warning-item warning-item1">
                                        位置
                                    </div>
                                    <div class="warning-item warning-item2">
                                        设备
                                        <!-- <span class="device-totle">19</span> -->
                                    </div>
                                    <div class="warning-item warning-item3">
                                        时间
                                    </div>
                                </div>
                                <template v-for="(v, i) in error_statistic">
                                    <div class="warning-list" :key="i">
                                        <div class="warning-item warning-item1">
                                            <span>{{v.name}}</span>
                                        </div>
                                        <div class="warning-item warning-item2">
                                            <span class="device-name color_yellow">{{v.device_name}}</span>
                                            <span class="device-des">{{v.error}}</span>
                                        </div>
                                        <div class="warning-item warning-item3">
                                            <span class="device-des">--</span>
                                            <span class="device-des">--</span>
                                        </div>
                                    </div>
                                </template>

                                <div class="nodata" v-if="error_statistic.length===0" style="color:#fff;">-- 暂无数据 --</div>

                                <!-- 箭头 -->
                                <div class="arrows-box">
                                    <span class="arrows-left-top"></span>
                                    <span class="arrows-left-bottom"></span>
                                    <span class="arrows-right-top"></span>
                                    <span class="arrows-right-bottom"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import echarts from "echarts"
import Service from '@/api/Service'
import { FormatDate, FormatDateDay } from '@/utils/utils.js'

import Sidebar from './Sidebar'

let Timer = null
let re_Timer = null
let day_Timer = null
var chart_month_electricity, chart_month_pump, chart_month_other, chart_day_electricity, chart_year_conservation;

export default {
    name: 'newHome',
    data () {
        return {
            fullScreen: false,
            day: "-1",
            type: "1",
            year: "",
            time: '',
            week: '',
            loading:false,
            loading1:false,
            loading2:false,
            loading3:false,

            current_data_detail: [],
            last_month_data_detail: [],
            error_statistic: [],       //   实时预警模块
            online_status_statistic: [],    //  在线情况
            yesterday_usage_statistic: [],  //  对比日用电量
            day_increase_percentage: [],    //  日增量
            plc_terminal_electricity: [],   //  子设备

            // 日用量
            today_statistic: {},  //  日用电量
            today_totle: 0, //  今日用电
            otherday_totle: 0,  //  对比用电
            today_percentage: "",    //  日增量
            today_data: [],
            other_data: [],

            // 能耗总览
            // 机房用电
            project_totle: 0,   //  
            last_project_totle: 0,  //
            increase_percentage: 0,
            project_data: [],
            last_project_data: [],

            // 水泵用电
            bump_totle: 0,
            bump_last_totle: 0,
            bump_increase_percentage: 0,
            bump_data: [],
            bump_last_data: [],
            // 空调用电
            kt_totle: 0,
            kt_last_totle: 0,
            kt_increase_percentage: 0,
            kt_data: [],
            kt_last_data: [],

            // 天气
            tem: '',
            tem1: '',
            tem2: '',
            humidity: '',
            air: '',
            air_level: '',
            wea_img: '',

            // 节能概况
            energy_totle: [],
            energy_pump: [],
            energy_air: [],

        };
    },

    components: { Sidebar },

    computed: {
        // 项目，项目列表
        ...mapGetters(['projectInfo','projectsystemInfo']),
        day_percent_class() {
            let value = this.today_percentage.split('%')[0]
            if(isNaN(value)) return 'cur-grow item-tendency-num'
            if(Number(value) === 0) return 'cur-grow item-tendency-num'
            if(Number(value) > 0)  return 'cur-grow item-tendency-num red'
            if(Number(value) < 0)  return 'cur-grow item-tendency-num green'
        }
    },
    mounted() {
        this.$nextTick(()=>{

            // 基于准备好的dom，初始化echarts实例
            chart_month_electricity = echarts.init(document.getElementById('chart_month_electricity'));
            chart_month_pump = echarts.init(document.getElementById('chart_month_pump'));
            chart_month_other = echarts.init(document.getElementById('chart_month_other'));
            chart_day_electricity = echarts.init(document.getElementById('chart_day_electricity'));
            chart_year_conservation = echarts.init(document.getElementById('chart_year_conservation'));

            this.getData()  //  当前设备状态
            
            re_Timer = setInterval(()=>{
                this.getData()  //  当前设备状态
            }, 60 * 1000)

            day_Timer = setInterval(() => {
                this.getDayStatic() //  日用量
                this.getWeather() 
            }, 5 * 60 * 1000);
        })
    },
    async created() {
        // this.loading = true
        this.loading1 = true
        this.loading2 = true
        this.loading3 = true
		
		let time = FormatDate('yyyy-MM-dd HH:mm:ss')
        await this.$store.dispatch("GetProjectSystemInfo")
		await this.$store.dispatch("GetProjectInfo")
        this.getNowDate()   
        this.getWeather()   //  天气
        this.getMonthElectricity()  //  能耗总览
        this.getEnergyConservation(time);   // 节能概况
        await this.getDayStatic() //  日用量
        // this.loading = false
        
    },
    destroyed() {
        window.clearInterval(Timer)
        window.clearInterval(re_Timer)
        window.clearInterval(day_Timer)
        
    },
    methods: {
        async getData(){
            let res = await Service.getStatisticsData();
            if(res) {
                // 实时预警
                this.error_statistic = res.error_statistic === null ? [] : res.error_statistic.slice(0, 5)   //  故障统计
                
                // 设备在线情况
                let arr = res.online_status_statistic === null ? [] : res.online_status_statistic
                this.online_status_statistic = arr.map(v=>{
                    v.percent = (v.online_status_sum/v.sum).toFixed(2)*100+"%"
                    return v
                })
            }
        },
        async getEnergyConservation(time) {
            let res = await Service.getEnergyConservation({time});
            this.loading2 = false
            if(res) {
                let fee_conservation = res.fee_conservation
                // 节能概况
                // 总
                let energy_totle = [];
                if(fee_conservation.electricity_statistic_list && fee_conservation.electricity_statistic_list.length>0) {
                    energy_totle = fee_conservation.electricity_statistic_list.map(v=>{
                        return v.value
                    })
                }
                this.energy_totle = energy_totle;
                // 水泵
                if(fee_conservation.pump_energy_conservation && fee_conservation.pump_energy_conservation.length>0) {
                    this.energy_pump = fee_conservation.pump_energy_conservation.map(v=>{return v.value})
                }

                // 空调系统
                let list = []
                if(fee_conservation.energy_conservation && fee_conservation.energy_conservation.length>0) {
                    this.energy_air = fee_conservation.energy_conservation.map(v=>{
                        return v.value
                    })
                }

                this.initEngerSituation()
            }
        },
        async getDayStatic() {
            let res = await Service.getPlcdayElectricity()
            if(res) {
                this.today_statistic = res

                this.initDayusage()
            }
        },
        async getMonthElectricity() {
            // 能耗总览
            let res = await Service.getMonthElectricityByPID()
            this.loading1 = false
            if(res) {
                // 水泵用电
                let pumps = res.pumps_electricity_statistic
                this.bump_totle = pumps.current_month_electricity.toFixed(2)
                this.bump_last_totle = pumps.compare_month_electricity.toFixed(2)
                this.bump_increase_percentage = pumps.increase_percentage
                this.bump_data = pumps.current_month_data_detail === null ? [] : pumps.current_month_data_detail
                this.bump_last_data = pumps.compare_month_data_detail === null ? [] : pumps.compare_month_data_detail

                let kt = res.plc_electricity_statistic
                this.kt_totle = kt.current_month_electricity.toFixed(2)
                this.kt_last_totle = kt.compare_month_electricity.toFixed(2)
                this.kt_increase_percentage = kt.increase_percentage
                this.kt_data = kt.current_month_data_detail === null ? [] : kt.current_month_data_detail
                this.kt_last_data = kt.compare_month_data_detail === null ? [] : kt.compare_month_data_detail

                this.initEngerTotle()
                this.initOtherTotle()
            }
        },
        async getWeather(){
            let city_name = this.projectInfo.city.replace('市', '')
            let res = await Service.getWeather({city_name})
            this.loading3 = false
            if(res) {
                this.tem = res.tem.replace('℃', '')
                this.tem1 = res.tem1.replace('℃', '')
                this.tem2 = res.tem2
                this.humidity = res.humidity
                this.air = res.air
                this.air_level = res.air_level
                this.wea_img = res.wea_img
            }
        },
        // 能耗总览
        initEngerTotle() {
            let kt_data = this.kt_data.map(v=>{return v.value})
            let kt_last_data = this.kt_last_data.map(v=>{return v.value.toFixed(2)})
            
            this.initChartProject(kt_data, kt_last_data, chart_month_electricity)
        },
        // 处理子设备能耗总览统计
        initOtherTotle() {
            let bump_data = this.bump_data.map(v=>{return v.value})
            let bump_last_data = this.bump_last_data.map(v=>{return v.value.toFixed(2)})
            this.initChartProject(bump_data, bump_last_data, chart_month_pump)
        },
        // 日用量
        initDayusage() {
            try {
                
                if(this.type === "1") {
                    let today_arr = this.today_statistic.today_usage_statistic.filter(v=>{ return v.plc_terminal_type_name === '中央空调'})
                    let yesterday_arr = this.today_statistic.yesterday_usage_statistic.filter(v=>{ return v.plc_terminal_type_name === '中央空调'})
                    // 空调系统用量
                    let obj_today = today_arr[0]
                    this.today_data = obj_today.date_detail.map(v=>{return v.value.toFixed(2)})
                    this.today_totle = obj_today.day_usage.toFixed(2)

                    let other_today = yesterday_arr[0]
                    this.other_data = other_today.date_detail.map(v=>{return v.value.toFixed(2)})
                    this.otherday_totle = other_today.day_usage.toFixed(2)

                    this.today_percentage = this.today_statistic.day_increase_percentage[0]
                } else {
                    let today_arr = this.today_statistic.today_usage_statistic.filter(v=>{ return v.plc_terminal_type_name === '水泵'})
                    let yesterday_arr = this.today_statistic.yesterday_usage_statistic.filter(v=>{ return v.plc_terminal_type_name === '水泵'})
                    // 水泵用量
                    let obj_today = today_arr[0]
                    this.today_data = obj_today.date_detail.map(v=>{return v.value.toFixed(2)})
                    this.today_totle = obj_today.day_usage.toFixed(2)

                    let other_today = yesterday_arr[0]
                    this.other_data = other_today.date_detail.map(v=>{return v.value.toFixed(2)})
                    this.otherday_totle = other_today.day_usage.toFixed(2)

                    this.today_percentage = this.today_statistic.day_increase_percentage[1]
                }
            } catch (error) {
                console.log("统计数据有误", error);
            }
            
            this.initChartDay(this.today_data, this.other_data)
        },
        initChartDay(nowDay, otherDay) {
            var option_day = {
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                    padding: [
                        5,  // 上
                        10, // 右
                        5,  // 下
                        10, // 左
                    ],
                    textStyle: {
                        color: 'rgba(51, 51, 51, 1)'
                    },
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                legend: {
                    data: ['今日', '对比'],
                    textStyle: {
                        color: 'rgba(255, 255, 255, 1)',
                    },
                    right: 160,
                    top: 10,
                },
                grid: {
                    left: 50,
                    right: 20,
                    bottom: 30,
                    top: 30,
                },
                
                xAxis: [
                    {
                        type: 'category',
                        axisLabel: {
                            textStyle: {
                                color: 'rgba(207, 234, 255, 1)'
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(220, 222, 227, 1)'
                            },
                        },
                        data: ['0时', '1时', '2时', '3时', '4时', '5时', '6时', '7时', '8时', '9时', '10时', '11时', '12时', '13时','14时', '15时', '16时', '17时', '18时', '19时', '20时', '21时', '22时', '23时']
                    },
                ],

                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            textStyle: {
                                color: 'rgba(207, 234, 255, 1)'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: 'rgba(220, 222, 227, .5)',
                                type: 'dashed',
                            }
                        },
                        axisLine: {
                            lineStyle: {
                            opacity: 0 
                            },
                        },
                        name: 'KW/h',
                        nameTextStyle: {
                            color: "rgba(241, 255, 77, 1)"
                        }
                    }
                ],
                series: [
                    {
                        name: '今日',
                        type: 'line',
                        data: nowDay,
                        smooth: true,
                        itemStyle: {
                            color: 'rgba(196, 178, 27, 1)'
                        },
                    },
                    {
                        name: '对比',
                        type: 'line',
                        smooth: true,
                        itemStyle: {
                            color: 'rgba(56, 191, 96, 1)'
                        },
                        data: otherDay,
                    },
                ],
            }
            chart_day_electricity.setOption(option_day);
        },
        // 机房PLC总用电量
        initChartProject(nowDay, otherDay, id) {
            // 指定图表的配置项和数据
            var option = {
                color: ['#fff'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                padding: [
                    5,  // 上
                    5, // 右
                    5,  // 下
                    5, // 左
                ],
                grid: {
                    left: 5,
                    right: 5,
                    bottom: 5,
                },
                xAxis: [
                    {
                        show: false,
                        type: 'category'
                    }
                ],
                yAxis: [
                    {
                        show: false,
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '本月',
                        type: 'line',
                        stack: '电量',
                        data: nowDay,
                        smooth: true,
                        symbol: 'none',
                        itemStyle: {
                        color: 'rgba(241, 255, 77, 0.64)'
                        },
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(241, 255, 77, 0.64)'
                            }, {
                                offset: 1,
                                color: 'rgba(255, 255, 255, 0.41)'
                            }])
                        },
                    },
                    {
                        name: '上月',
                        type: 'line',
                        symbol: 'none',
                        smooth: true,
                        stack: '电量',
                        data: otherDay,
                    },
                ]
            }
            id.setOption(option);
        },
        // 节能概况
        initEngerSituation() {
            let data = [
                {
                    name: '空调节能电费',
                    type: 'bar',
                    stack: '节能电费',
                    data: this.energy_air
                },
                {
                    name: '水泵节能电费',
                    type: 'bar',
                    stack: '节能电费',
                    data: this.energy_pump
                },
                {
                    name: '总电费',
                    type: 'bar',
                    data: this.energy_totle
                }
            ]
            var option_year = {
                color: ['rgba(204, 117, 80, 1)', 'rgba(115, 154, 255, 1)', 'rgba(212, 162, 55, 1)'],
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                    padding: [
                        5,  // 上
                        10, // 右
                        5,  // 下
                        10, // 左
                    ],
                    textStyle: {
                        color: 'rgba(51, 51, 51, 1)'
                    },
                },
                legend: {
                    data: ['空调节能电费', '水泵节能电费', '总电费'],
                    textStyle: {
                        color: 'rgba(255, 255, 255, 1)',
                    },
                    right: 20,
                    top: 0,

                },
                grid: {
                    left: 80,
                    right: 20,
                    bottom: 30,
                    top: 30,
                },

                xAxis: [
                    {
                        type: 'category',
                        axisLabel: {
                            textStyle: {
                                color: 'rgba(207, 234, 255, 1)'
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(220, 222, 227, 1)'
                            },
                        },
                        data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
                    },
                ],

                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            textStyle: {
                                color: 'rgba(207, 234, 255, 1)'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: 'rgba(220, 222, 227, .3)',
                                type: 'solid',
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                opacity: 0
                            },
                        },
                        name: '元',
                        nameTextStyle: {
                            color: "rgba(241, 255, 77, 1)"
                        }
                    }
                ],
                series: data,
            }
            chart_year_conservation.setOption(option_year);
        },
        handleChangeType(val) {
            this.initDayusage()
        },
        // 右上角时间
        getNowDate() {
            this.year = FormatDate("yyyy年MM月dd日");
            this.week = FormatDateDay();

            Timer = window.setInterval(() => {
                this.time = FormatDate("HH:mm:ss")
            }, 1000);
        },
        handleFullScreen(bool) {
            this.fullScreen = bool;

            let element = document.getElementById("home_box");
            if (!bool) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
        }
    }
}

</script>
<style>

</style>